export default "__VITE_ASSET__Cfo57HVC__"